import { ButtonVariant } from "react-bootstrap/types";

const enumTranslator = (variants: ButtonVariant) => {
  return variants as string;
};

export default enumTranslator;
